import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ErrorComponent } from '../../shared/error/error.component';
import { DashboardMonitorComponent } from './dashboard-monitor/dashboard-monitor.component';

const cRoutes: Routes = [

  {
    path: '',
    component: DashboardMonitorComponent
  }

];


@NgModule({
  imports: [
    RouterModule.forChild(
      cRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class MonitorRoutingModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/monitor-agents/monitor-routing.module.ts